<payee-popup
  [onCancel]="cancel"
  [onSubmit]="submit"
>
  <ng-template #payeePopupTitleTemplate>
    <h1>Ügyvédi iroda törlése</h1>
  </ng-template>

  <payee-form-field>
    <span payee-label>Név</span>
    <input
      payee-input
      [formControl]="name"
    />
  </payee-form-field>
</payee-popup>
